// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1r","title":"e_2r","titleIcon":"e_3r","summary":"e_4r","sourcesTitle":"e_5r","sources":"e_6r","source":"e_7r"};